import type {Nullable} from '../../utility-types';

import {logger} from '../../logger';
import {DOT, Z} from '../utils';
import {convertMinutesToUtcOffset} from './convertMinutesToUtcOffset';

export function processUtcOffset(
  isoDate: string,
  utcOffset?: Nullable<number>,
) {
  let offset = utcOffset;

  if (offset == null) {
    return isoDate.slice(0, isoDate.indexOf(DOT));
  }

  if (isNaN(parseInt(offset as unknown as any, 10))) {
    logger.error('Invalid DateTimeObj.utcoffset.');
    offset = 0;
  }

  const shouldFormatOffset = offset !== 0;

  return shouldFormatOffset
    ? isoDate.replace(Z, convertMinutesToUtcOffset(offset))
    : isoDate;
}
